export abstract class FormDataBase {
  // tslint:disable-next-line: variable-name
  private _form: FormDataBase | null = null;

  setForm(form: FormDataBase): void {
    this._form = form;
  }

  updateFormField(fieldName: string, value: string) {
    (this._form as any)[fieldName] = value;
  }

}
